/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/reeferhistory.cs.d.ts" />
/// <reference path="../../../../../RcWebModels/RcdHistoryUI.cs.d.ts" />
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import DateFormat from 'dateformat';
import moment from 'moment';
import { DateTime } from 'react-datetime-bootstrap';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { GridToolBar } from '../sharedcomponents/GridToolBar';
import { GridToolBarExcel } from '../sharedcomponents/GridToolBarExcel';
import Formatters from '../../actions/Formatters';
import DryFormatters from '../../actions/DryFormatter';
import $ from 'jquery';
import * as Exceljs from '../../actions/ExportToExcel.js';
import { GridPreferenceControl } from './../sharedcomponents/GridPreferenceControl';
import { EmailControl } from './../sharedcomponents/EmailControl';
import { EmailControlExcel } from './../sharedcomponents/EmailControlExcel';

import { RCUtils } from './../../RCUtils';
// pull in the ag-grid styles we're interested in
import './../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import './../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';

var Config: any = require('../../Config.json');
var Excel = Exceljs.default;

export interface DryHistoryState {
    rowData: server.DryHistoryUI[],
    rowDataForRCD: server.RcdHistoryUI[],
    HistoryFiltersForRCD: RcdHistorySearchFilters,
    columnDefs: any[],
    HistoryFilters: DryHistoryFilter,
    reeferFormatter: server.ReeferFormatter
    pageSize: any;
    gridApiParams: any;
    RCDMasterId: string;
    emailHtml: any;
    selectedItems: any[];
    exportFields: ExportFields;
    PreferenceDTTM: any;
    GridToolBarHtml: any;
    defaultColDef: any[];
    rowGroupPanelShow: string;
    groupDefaultExpanded: number;
    autoGroupColumnDef: any;
}
class ExportFields {
    ExportData: string;
}
var colDefs;
var self;
var functionId;
var coppiedData;
var coppiedDataWithHeader;
var columnDefs2: any[];
export class DryDetailsHistory extends React.Component<any, DryHistoryState> {
    constructor(props: any) {
        super(props);
        functionId = 49; // functionId for DryHistory Grid
        var filterSet = new DryHistoryFilter();
        var filterSetForRCD = new RcdHistorySearchFilters();
        //var columnDefs = this.createColumnDefs();
        var exportData = new ExportFields();
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        this.state = {
            rowData: [],
            rowDataForRCD: [],
            columnDefs: [],
            HistoryFilters: filterSet,
            HistoryFiltersForRCD: filterSetForRCD,
            reeferFormatter: props.stateData.reeferFormatter,
            RCDMasterId: null,
            pageSize: 25,
            gridApiParams: [],
            emailHtml: '',
            selectedItems: [],
            exportFields: exportData,
            PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm),
            GridToolBarHtml: '',
            defaultColDef: [],
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: -1,
            autoGroupColumnDef: { minWidth: 200 }
        };

        self = this;
    }

    bindDryHistoryData(stateData: any) {
        //var historyData = stateData.dryHistoryData;
        var statusData = stateData.dryDetailsData;

        /*var toDTTM = this.state.PreferenceDTTM;
        var modifiedDttm = new Date(toDTTM);
        modifiedDttm.setDate(modifiedDttm.getDate() - 1);
        var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
        */
        var toDTTM = this.props.ToDate;
        var fromDTTM = this.props.FromDate;

        var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
        var toDate = moment(new Date(toDTTM)).endOf('day').toString();
        this.state.HistoryFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        this.state.HistoryFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        this.state.HistoryFilters.AssetNumber = statusData.AssetMasterID;
        //this.state.HistoryFilters.AssetNumber = statusData.DryId;
        this.state.HistoryFilters.DeviceNumber = statusData.RCDID;
        this.state.HistoryFilters.EventCode = null;
        //this.setState({ rowData: historyData }, () => this.bindGridToolBar());

        if (this.props.stateData.dryHistoryData != undefined && this.props.stateData.dryHistoryData != null) {
            if (this.props.stateData.dryHistoryData.length == 0) {
                this.ApplyDryHistorySearch();
            }
            else {
                this.setState({
                    reeferFormatter: this.props.stateData.reeferFormatter,
                    rowData: this.props.stateData.dryHistoryData
                }, () => this.bindGridToolBar());
            }
        }
        else
            this.ApplyDryHistorySearch();

        if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != [] && self.state.gridApiParams.length > 0) {
            self.state.gridApiParams.paginationGoToFirstPage();
        }
    }

    bindGridToolBar() {
        this.setState({ GridToolBarHtml: this.renderGridToolBar(self.state.gridApiParams) });
    }

    bindRcdHistoryData(stateData: any) {
        var historyData = stateData.rcdHistoryData;
        var statusData = stateData.dryDetailsData;
        if (statusData.RCDMasterID != 0) {
            this.state.HistoryFiltersForRCD.Units = statusData.RCDMasterID;
        }
        /*
        var toDTTM = this.state.PreferenceDTTM;
        var modifiedDttm = new Date(toDTTM);
        modifiedDttm.setDate(modifiedDttm.getDate() - 1);
        var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
        */
        var toDTTM = this.props.ToDateRCD;
        var fromDTTM = this.props.FromDateRCD;

        var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
        var toDate = moment(new Date(toDTTM)).endOf('day').toString();
        this.state.HistoryFiltersForRCD.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        this.state.HistoryFiltersForRCD.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        self.setState({
            RCDMasterId: statusData.RCDMasterID
        })

        //this.setState({ rowDataForRCD: historyData }, () => this.bindGridToolBar());

        if (this.props.stateData.rcdHistoryData != undefined && this.props.stateData.rcdHistoryData != null) {
            if (this.props.stateData.rcdHistoryData.length == 0) {
                this.ApplyDryHistorySearch();
            }
            else {
                this.setState({
                    reeferFormatter: this.props.stateData.reeferFormatter,
                    rowDataForRCD: this.props.stateData.rcdHistoryData
                }, () => this.bindGridToolBar());
            }
        }
        else
            this.ApplyDryHistorySearch();

        if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != [] && self.state.gridApiParams.length > 0) {
            self.state.gridApiParams.paginationGoToFirstPage();
        }
    }

    componentWillReceiveProps(nextprops: any) {
        if (nextprops.stateData != undefined && nextprops.stateData != null) {
            if (nextprops.IsDry == true)
                this.bindDryHistoryData(nextprops.stateData);
            else
                this.bindRcdHistoryData(nextprops.stateData);
        }
    }

    ValidateHistoryDates() {
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var currentDttm = Formatters.DateTimeFormatter(currentUtcDttm);
        this.setState({ PreferenceDTTM: currentDttm });
        //var currentDttm = this.state.PreferenceDTTM;
        var fromDttm = this.state.HistoryFilters.FromDate;
        var toDttm = this.state.HistoryFilters.ToDate;
        if (fromDttm == "Invalid date" || fromDttm == null || fromDttm == "")
            return "Invalid From Date.";

        if (toDttm == "Invalid date" || toDttm == null || toDttm == "")
            return "Invalid To Date.";

        if (moment(new Date(fromDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "From date should not be greater than current date.";

        if (moment(new Date(toDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "To date should not be greater than current date.";

        if (moment(new Date(fromDttm)) > moment(new Date(toDttm)))
            return "From Date should not be greater than To Date.";

        return "";
    }

    ValidateRcdHistoryDates() {
        var fromDttm = this.state.HistoryFiltersForRCD.FromDate;
        var toDttm = this.state.HistoryFiltersForRCD.ToDate;
        if (fromDttm == "Invalid date" || fromDttm == null || fromDttm == "")
            return "Invalid From Date.";

        if (toDttm == "Invalid date" || toDttm == null || toDttm == "")
            return "Invalid To Date.";

        if (moment(new Date(fromDttm)) > moment(new Date(toDttm)))
            return "From Date should not be greater than To Date.";

        return "";
    }

    updateDryCommandsDimensions() {
        if (this.props.IsDry == true) {
            $("#HistoryStatusGrid .ag-root-wrapper-body").css('min-height', $(window).height() - 289);
            $("#HistoryStatusGrid .ag-root-wrapper-body").css('height', $(window).height() - 289);
            $("#HistoryStatusGrid .ag-root-wrapper-body").css('max-height', $(window).height() - 289);
        }
        else {
            $("#RCDHistoryStatusGrid .ag-root-wrapper-body").css('min-height', $(window).height() - 289);
            $("#RCDHistoryStatusGrid .ag-root-wrapper-body").css('height', $(window).height() - 289);
            $("#RCDHistoryStatusGrid .ag-root-wrapper-body").css('max-height', $(window).height() - 289);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDryCommandsDimensions.bind(this));
    }

    componentDidMount() {
        this.updateDryCommandsDimensions();
        window.addEventListener("resize", this.updateDryCommandsDimensions.bind(this));
        $(".context-menu").hide();
        $("#contextmenu").hide();
        Excel.preventDefault();
       
       
        
        
        var IsDry = this.props.IsDry;
        if (this.props.stateData != undefined && this.props.stateData != null) {
            var stateData = this.props.stateData;
        }
        if (IsDry == true) {
            colDefs = this.createColumnDefs();
            columnDefs2 = this.createColumnDefs();
            this.bindDryHistoryData(stateData);
        }

        else {
            colDefs = this.createColumnDefsForDevice();
            columnDefs2 = this.createColumnDefsForDevice();;
            this.bindRcdHistoryData(stateData);
        }

        //this.setState({ GridToolBarHtml: this.renderGridToolBar() });
    }

    onDryGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
        var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        GridPreferenceControl.HistoryGridPreferenceColumns(functionId, params.api, "DryDetailsHistory");//26724 - added missing parameter
        self.setState({ GridToolBarHtml: self.renderGridToolBar(params.api) });
    }

    onRcdGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
        self.setState({ GridToolBarHtml: self.renderGridToolBar(params.api) });
    }

    FromDateChange(date) {
        var filters = self.state.HistoryFilters;
        filters.FromDate = date;
        self.setState({
            HistoryFilters: filters
        });

        this.props.HoldHistoryDates(date, null);
    }

    ToDateChange(date) {
        var filters = self.state.HistoryFilters;
        filters.ToDate = date;
        self.setState({
            HistoryFilters: filters
        });

        this.props.HoldHistoryDates(null, date);
    }
    RcdFromDateChange(date) {
        var filters = self.state.HistoryFiltersForRCD;
        filters.FromDate = date;
        self.setState({
            HistoryFiltersForRCD: filters
        });

        this.props.HoldRCDHistoryDates(date, null);
    }

    RcdToDateChange(date) {
        var filters = self.state.HistoryFiltersForRCD;
        filters.ToDate = date;
        self.setState({
            HistoryFiltersForRCD: filters
        });

        this.props.HoldRCDHistoryDates(null, date);
    }
    onCellClickedCopy(event) {
        coppiedDataWithHeader = event.colDef.headerName + " \r\n" + event.value;
        coppiedData = event.value;
    }

    ApplyDryHistorySearch() {
        var message;
        if (this.props.IsDry == false) {
            message = this.ValidateRcdHistoryDates();
        }
        else {
            message = this.ValidateHistoryDates();
        }
        if (message != "") {
            PopupWindow.showErrorMessage("Alert", message);
            return;
        }
        $('#globalLoader').show();
        if (this.state.reeferFormatter === null && this.props.IsGenset == true) {
            var fromDate = moment(new Date(this.state.HistoryFilters.FromDate)).toString();
            var toDate = moment(new Date(this.state.HistoryFilters.ToDate)).toString();
            this.state.HistoryFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            this.state.HistoryFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            var filterParams = JSON.stringify(this.state.HistoryFilters);
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.ReeferFormatter>)
                .then(data => {
                    this.setState({
                        reeferFormatter: data
                    }, () => {
                        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                        fetch(request)
                            .then(RCUtils.handleError)
                            .then(response => response.json() as Promise<server.DryHistoryUI[]>)
                            .then(data1 => {
                                this.setState({
                                    rowData: data1
                                }, () => {
                                        this.props.HoldHistoryData(data, data1, null);
                                        this.bindGridToolBar();
                                });
                                $('#globalLoader').hide();
                            });

                           
                    });
                });
        }
        else if (this.props.IsDry == false) {
            var fromDate = moment(new Date(this.state.HistoryFiltersForRCD.FromDate)).toString();
            var toDate = moment(new Date(this.state.HistoryFiltersForRCD.ToDate)).toString();
            this.state.HistoryFiltersForRCD.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            this.state.HistoryFiltersForRCD.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            var filterParams = JSON.stringify(this.state.HistoryFiltersForRCD);
            var rcdColDefs = this.createColumnDefsForDevice();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.ReeferFormatter>)
                .then(data => {
                    this.setState({
                        reeferFormatter: data
                    }, () => {
                        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/RcdStatus/RcdHistoryDataByDeviceSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                        fetch(request)
                            .then(RCUtils.handleError)
                            .then(response => response.json() as Promise<server.RcdHistoryUI[]>)
                            .then(data1 => {
                                this.setState({
                                    rowDataForRCD: data1
                                }, () => {
                                        this.props.HoldHistoryData(data, null, data1);
                                         this.bindGridToolBar();
                                });
                                $('#globalLoader').hide();
                            });

                          
                    });
                });

        }
        else {
            var fromDate = moment(new Date(this.state.HistoryFilters.FromDate)).toString();
            var toDate = moment(new Date(this.state.HistoryFilters.ToDate)).toString();
            this.state.HistoryFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            this.state.HistoryFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            var filterParams = JSON.stringify(this.state.HistoryFilters);
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.DryHistoryUI[]>)
                .then(data1 => {
                    this.setState({
                        rowData: data1
                    }, () => {
                            this.props.HoldHistoryData(this.state.reeferFormatter, data1, null);
                        this.bindGridToolBar();
                    })
                    $('#globalLoader').hide();
                });
        }
    }

    createColumnDefsForDevice() {

        return [
            { headerName: "ALM", field: "R_HighestSeverityLevel", width: 65, cellRenderer: Formatters.runStateFormatter },
            { headerName: "RUN", field: "RunState", width: 65, cellRenderer: Formatters.runStateFormatter },
            //{ headerName: "SW", field: "IgnitionOn", width: 65, cellRenderer: Formatters.gensetSwitchFormatterImg },
            //{ headerName: "ENG", field: "GensetRunning", valueGetter: (params) => { return Formatters.EngineSorting(params); }, width: 65, cellRenderer: Formatters.gensetRunningFormatter },
            { headerName: "OEM", field: "ReeferOEMTypeCd", width: 70, cellRenderer: Formatters.oemTypeFormatter },
            { headerName: "Device ID", field: "RCDID", cellClass: 'bigInt',cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Last Asset ID", field: "AssetNumber", cellRenderer: Formatters.stringTypeFormatter, width: 110 },
            { headerName: "Asset Type", field: "AssetType", cellRenderer: Formatters.stringTypeFormatter, width: 110 },
            { headerName: "Last Event", field: "LastEvent", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Alert", field: "Alerts", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Event Time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "R_EventDTTM", width: 150, cellRenderer: Formatters.dateTypeFormatter },
            { headerName: "Reported Time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "R_ModifiedDTTM", width: 150, cellRenderer: Formatters.dateTypeFormatter },
            { headerName: "City", field: "City", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "State", field: "State", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Country", field: "Country", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Zip", field: "Zip", cellRenderer: Formatters.stringTypeFormatter, width: 100 },
            { headerName: "Device Fence", field: "GeofenceName", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Server Fence", field: "ServerGeofenceName", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            //{ headerName: "Region Fence", field: "RegionGeofenceName", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Device Fence ID", field: "Geofence", cellRenderer: Formatters.stringTypeFormatter, width: 110 },
            { headerName: "Server Fence ID", field: "ServerGeofence", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            //{ headerName: "Region Fence ID", field: "RegionGeofence", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Loc Coords", field: "GPSCoords", cellRenderer: Formatters.GPSCoordsFormatter, width: 150 },
            { headerName: "Loc age (h:m:s)", field: "GPSLastLock", cellRenderer: Formatters.secondsToTimeConverter, width: 150 },
            { headerName: "MCC (country)", field: "CountryName", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "MNC", field: "MNC", cellRenderer: Formatters.MNCTypeFormatter, width: 70 },
            { headerName: "LAC", field: "TowerLocalizationAreaCode", cellRenderer: Formatters.stringTypeFormatter, width: 70 },
            { headerName: "Tower ID", field: "TowerBaseStationID", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 130 },
            { headerName: "In Geofence", field: "IsInsideGeofence", width: 90, cellRenderer: Formatters.YesNoConverter },
            { headerName: "Device supply (V)", field: "ReeferACPowerLevel", cellRenderer: Formatters.sensorDataFormatter, width: 120 },
            { headerName: "Device pwr source", field: "RCDPowerSourceCd", cellRenderer: Formatters.rcdPowerSourceFormatter, width: 150 },
            { headerName: "Device FW ver", field: "RCDFirmwareVersion", cellRenderer: Formatters.stringTypeFormatter, width: 130 },
            { headerName: "Device BL ver", field: "RCDBootloaderVersion", cellRenderer: Formatters.stringTypeFormatter, width: 130 },
            { headerName: "Device Mesh FW ver", field: "RCDMeshFirmwareVersion", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Device temp. ", headerValueGetter: Formatters.TempHeaderFormatter, cellRenderer: Formatters.TemperatureFormatter, field: "DeviceTemp", width: 130 },
            { headerName: "Device Bat. (V)", field: "BatteryVoltage", cellRenderer: Formatters.stringTypeFormatter, width: 130 },
            { headerName: "Geofence Revision", field: "RevisionNum", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "MSISDN", field: "MSISDN", cellClass: 'bigInt',cellRenderer: Formatters.stringTypeFormatter, width: 140 },
            { headerName: "IMSI", field: "SIM_IMSI", cellClass: 'bigInt',cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "ICCID", field: "ICCID", cellClass: 'bigInt', cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "EUI", field: "EUI", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
            { headerName: "Cell Signal", field: "RSSI", cellRenderer: Formatters.RSSITypeFormatter, width: 80 },
            { headerName: "Reporting (min)", field: "RCDReportingInterval", cellRenderer: Formatters.stringTypeFormatter, width: 130 }
        ];
    }

    createColumnDefs() {
        return [
            {
                headerName: 'Group',
                minWidth: 210,
                hide: true
            },
            {
                headerName: 'State Indicators',
                children: [
                    {
                        headerName: "PWR", field: "BatteryStatus", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        resizable: true, valueGetter: (params) => { return DryFormatters.dryBatteryStatusSorting(params); },
                        filterParams: { valueGetter: params => { return DryFormatters.dryPwrStateFormatterFilter(params); } },
                        cellRenderer: DryFormatters.dryBatteryStatusFormatter, width: 70
                    },

                    { headerName: "VSL", field: "VesselCd", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "VesselCd"); }, cellRenderer: Formatters.stringTypeValueFormatter },
                    { headerName: "TRIP", field: "TripStatusCdAndDFlag", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, tooltipField: "TripNameAndStatus", width: 70, valueGetter: (params) => { return Formatters.TripSorting(params); }, cellRenderer: Formatters.TripstatusIndicator }
                ]
            },
            {
                headerName: "Latest Event",
                children: [
                    { headerName: "Dry ID", field: "AssetNumber", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "AssetNumber"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 140 },
                    { headerName: "Event", field: "EventDescription", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EventDescription"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 150, enableTooltip: true },
                    { headerName: "Event Time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterEventDTTMForFilter(params); } }, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "EventDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                ]
            },
            {
                headerName: 'Last Reported Device Data',
                children: [
                    { headerName: "Device Fence", field: "FenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "FenceName"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 150 },
                    { headerName: "Device Fence ID", field: "FenceNameID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "FenceNameID"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 150 },
                    { headerName: "Server Fence", field: "BackendGeofenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BackendGeofenceName"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 150 },
                    { headerName: "Server Fence ID", field: "BackendGeofenceNameID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "BackendGeofenceNameID"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 150 },
                    // { headerName: "Region Fence", field: "RegionGeofence", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    // { headerName: "Region Fence ID", field: "RegionGeofenceName", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    { headerName: "Geofence Revision", field: "GeofenceDefinitionRevision", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return DryFormatters.floatTypeSortingFieldName(params, "GeofenceDefinitionRevision"); }, cellRenderer: Formatters.floatTypeValueFormatter, width: 150 },
                    { headerName: "City", field: "City", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "City"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 150 },
                    { headerName: "State", field: "State", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "State"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 70 },
                    { headerName: "Country", field: "Country", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Country"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 70 },
                    { headerName: "Zip", field: "ZipCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ZipCode"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 130 },
                    //{ headerName: "Battery (V)", field: "DeviceBattery", cellRenderer: Formatters.BattVoltageFormatter, width: 140 },
                    { headerName: "Loc Coords", field: "GPSCoords", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.GPSCoordsSorting(params); }, filterParams: { valueGetter: params => { return Formatters.GPSCoordsForFilter(params); } }, cellRenderer: Formatters.GPSCoordsFormatter, width: 140 },
                    { headerName: "Loc age (h:m:s)", field: "GPSLastLock", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.secondsToTimeConverterFilter(params); } }, valueGetter: (params) => { return Formatters.secondsToTimeConverterFilter(params); }, width: 140 },
                    { headerName: "Loc HDOP", field: "DryGPSHDOP", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return DryFormatters.floatTypeSortingFieldName(params, "DryGPSHDOP"); }, cellRenderer: Formatters.floatTypeValueFormatter, width: 100 },
                    { headerName: "Loc Sat. Count", field: "DryGPSSatelliteCount", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return DryFormatters.floatTypeSortingFieldName(params, "DryGPSSatelliteCount"); }, cellRenderer: Formatters.floatTypeValueFormatter, width: 70 },
                    { headerName: "MCC (country)", field: "CountryName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "CountryName"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 130 },
                    { headerName: "MNC", field: "MNC", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "MNC"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 140 },
                    { headerName: "LAC", field: "TowerLocalizationAreaCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "TowerLocalizationAreaCode"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 140 },
                    { headerName: "Tower ID", field: "TowerBaseStationID", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "TowerBaseStationID"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 150 },
                    { headerName: "Device ID", field: "RCDID", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDID"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 100 },
                    { headerName: "Device FW", field: "FirmwareVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "FirmwareVersion"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 70 },
                    {
                        headerName: "Device Bat. (V)", field: "BattVoltage", enableRowGroup: true, cellClass: 'bigInt', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.BattVoltageSorting(params.data.BattVoltage); },
                        filterParams: { valueGetter: params => { return Formatters.DeviceBattVoltageFormatterForFilter(params); } }, cellRenderer: Formatters.BattVoltageValueFormatter, width: 130
                    },
                    { headerName: "MSISDN", field: "MSISDN", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "MSISDN"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 140 },
                    { headerName: "IMSI", field: "SIM_IMSI", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "SIM_IMSI"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 140 },
                    { headerName: "ICCID", field: "ICCID", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt', valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "ICCID"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 150 },
                    { headerName: "EUI", field: "EUI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "EUI"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 100 },
                    {
                        headerName: "Cell Signal", field: "RSSI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.RSSISorting(params); },
                        filterParams: { valueGetter: params => { return Formatters.RSSITypeFormatterFilter(params); } }, cellRenderer: Formatters.RSSITypeFormatter, width: 70
                    },
                    {
                        headerName: "Speed (mph)", field: "DrySpeed", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, filterParams: { valueGetter: params => { return DryFormatters.SpeedConverterFilter(params); } },
                        valueGetter: (params) => { return DryFormatters.floatTypeSortingFieldName(params, "DrySpeed"); }, cellRenderer: DryFormatters.SpeedConverter, width: 130
                    },
                    { headerName: "Miles", field: "Miles", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return DryFormatters.floatTypeSortingFieldName(params, "Miles"); }, cellRenderer: Formatters.floatTypeValueFormatter, width: 150 },
                    {
                        headerName: "Door", field: "Door1Open", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        filterParams: { valueGetter: params => { return DryFormatters.doorFormatterFilter(params); } },
                        valueGetter: (params) => { return DryFormatters.DoorFormatterSorting(params); }, cellRenderer: DryFormatters.doorFormatter, width: 140
                    },
                    { headerName: "Device Type", field: "DeviceType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "DeviceType"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 140 },
                    { headerName: "Server Time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "CreatedDTTM", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterCreatedDTTMForFilter(params); } }, valueGetter: (params) => { return Formatters.dateTypeSortingFieldName(params, "CreatedDTTM"); }, cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                    { headerName: "Reporting (min)", field: "RCDReportingInterval", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "RCDReportingInterval"); }, cellRenderer: Formatters.stringTypeValueFormatter, width: 180 }
                ]
            }
        ];
    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;

        self.setState({
            pageSize: pageSize
        });

        if (self.state.gridApiParams != null && self.state.gridApiParams != undefined && self.state.gridApiParams != [] && self.state.gridApiParams.length > 0) {
            self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
            self.state.gridApiParams.paginationGoToFirstPage();
        }
    }

    onSelectionChanged(params: any) {
        $("#contextmenu").show();
        var selectedDryData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedDryData.push(selectedRow);
        });

        self.setState({
            selectedItems: selectedDryData
        });
    }

    onRCDSelectionChanged(params: any) {
        $("#contextmenu").show();
        var selectedDryData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedDryData.push(selectedRow);
        });

        self.setState({
            selectedItems: selectedDryData
        });
    }

    getRCDContextMenuItems(params: any) {
        $("#divMsboxDynamicContent").html(null);
        var flag = false;
        var selected = params.api.getFocusedCell();

        var setRowIndex = selected.rowIndex;
        var row = params.api.getDisplayedRowAtIndex(setRowIndex);
        if (row != null && row != "undefined" && !row.group) {
            var rowId = row.id;
            var selectedrowNode = params.api.getRowNode(rowId);
            var sortflage = false;

            var parentEventId = selectedrowNode.data.ParentEventID;
            params.api.forEachLeafNode(function (NewrowNode, index) {
                if ((NewrowNode.data.ParentEventID === parentEventId)) {
                    selectedrowNode = NewrowNode;
                    return false;
                }
            });
            $.each(self.state.selectedItems, function (index, item) {
                if (item.ParentEventID == selectedrowNode.data.ParentEventID) {
                    flag = true;
                    return false;
                }
            });
            if (!flag)
                params.api.deselectAll();
            selectedrowNode.setSelected(true);
        }
        /*var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
        var tempArray = [];// if sort is clicked save in temp array
        params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
            tempArray.push(rowNode);
        });
        var resortitem = tempArray[selected.rowIndex];
        var sortflage = false;
        var parentEventId = resortitem.data.ParentEventID;
        params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
            if ((NewrowNode.data.ParentEventID === parentEventId)) {
                selectedrowNode = NewrowNode;
                return false;
            }
        });
        $.each(self.state.selectedItems, function (index, item) {
            if (item.ParentEventID == selectedrowNode.data.ParentEventID) {
                flag = true;
                return false;
            }
        });
        if (!flag)
            params.api.deselectAll();
        params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
        */
        $(".context-menu").show(); $("#contextmenu").show();
        Excel.preventDefault();

        $(".ag-cell").unbind("contextmenu");
        $(".ag-cell").bind('contextmenu', function (e) {
            $("#divMsboxDynamicContent").html(null);
            $("#contextmenu").show();
            var flag = false;
            var selected = params.api.getFocusedCell();

            var setRowIndex = selected.rowIndex;
            var row = params.api.getDisplayedRowAtIndex(setRowIndex);
            if (row != null && row != "undefined" && !row.group) {
                var rowId = row.id;
                var selectedrowNode = params.api.getRowNode(rowId);
                var sortflage = false;

                var parentEventId = selectedrowNode.data.ParentEventID;
                params.api.forEachLeafNode(function (NewrowNode, index) {
                    if ((NewrowNode.data.ParentEventID === parentEventId)) {
                        selectedrowNode = NewrowNode;
                        return false;
                    }
                });
                $.each(self.state.selectedItems, function (index, item) {
                    if (item.ParentEventID == selectedrowNode.data.ParentEventID) {
                        flag = true;
                        return false;
                    }
                });
                if (!flag)
                    params.api.deselectAll();
                selectedrowNode.setSelected(true);
            }
            /*var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
            var tempArray = [];// if sort is clicked save in temp array
            params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
                tempArray.push(rowNode);
            });
            var resortitem = tempArray[selected.rowIndex];
            var sortflage = false;
            var parentEventId = resortitem.data.ParentEventID;
            params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
                if ((NewrowNode.data.ParentEventID === parentEventId)) {
                    selectedrowNode = NewrowNode;
                    return false;
                }
            });
            $.each(self.state.selectedItems, function (index, item) {
                if (item.ParentEventID == selectedrowNode.data.ParentEventID) {
                    flag = true;
                    return false;
                }
            });
            if (!flag)
                params.api.deselectAll();
            params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
            */
            var height = $(window).height() - 200;
            var halfheight = ($(window).height()) / 2;
            var top = e.pageY + 5;
            if (height < top) {
                top = (top - halfheight) + 310;
            }

            var left = e.pageX;
            $(".context-menu").css({
                top: top + "px",
                left: left + "px"
            });

            $(".context-menu").show();
            e.preventDefault();
            return false;
        });

        $(document).contextmenu(function () {
            return false;
        });

        $(document).bind('contextmenu click', function () {
            $(".context-menu").hide();
        });

        $('.context-menu').bind('contextmenu', function () {
            return false;
        });
        $('.context-menu').on('click', 'li', function () {
            $(".context-menu").hide();
        });
    }

    getContextMenuItems(params: any) {
        $("#divMsboxDynamicContent").html(null);
        var flag = false;
        var selected = params.api.getFocusedCell();

        var setRowIndex = selected.rowIndex;
        var row = params.api.getDisplayedRowAtIndex(setRowIndex);
        if (row != null && row != "undefined" && !row.group) {
            var rowId = row.id;
            var selectedrowNode = params.api.getRowNode(rowId);
            var sortflage = false;

            var dryHistoryID = selectedrowNode.data.DCConditionLogID;
            params.api.forEachLeafNode(function (NewrowNode, index) {
                if ((NewrowNode.data.DCConditionLogID === dryHistoryID)) {
                    selectedrowNode = NewrowNode;
                    return false;
                }
            });
            $.each(self.state.selectedItems, function (index, item) {
                if (item.DCConditionLogID == selectedrowNode.data.DCConditionLogID) {
                    flag = true;
                    return false;
                }
            });
            if (!flag)
                params.api.deselectAll();
            selectedrowNode.setSelected(true);
        }
        /*var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
        var tempArray = [];// if sort is clicked save in temp array
        params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
            tempArray.push(rowNode);
        });
        var resortitem = tempArray[selected.rowIndex];
        var sortflage = false;
        var parentEventId = resortitem.data.ParentEventID;
        params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
            if ((NewrowNode.data.ParentEventID === parentEventId)) {
                selectedrowNode = NewrowNode;
                return false;
            }
        });
        $.each(self.state.selectedItems, function (index, item) {
            if (item.ParentEventID == selectedrowNode.data.ParentEventID) {
                flag = true;
                return false;
            }
        });
        if (!flag)
            params.api.deselectAll();
        params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
        */
        $(".context-menu").show(); $("#contextmenu").show();
        Excel.preventDefault();

        $(".ag-cell").unbind("contextmenu");
        $(".ag-cell").bind('contextmenu', function (e) {
            $("#divMsboxDynamicContent").html(null);
            $("#contextmenu").show();
            var flag = false;
            var selected = params.api.getFocusedCell();

            var setRowIndex = selected.rowIndex;
            var row = params.api.getDisplayedRowAtIndex(setRowIndex);
            if (row != null && row != "undefined" && !row.group) {
                var rowId = row.id;
                var selectedrowNode = params.api.getRowNode(rowId);
                var sortflage = false;

                var dryHistoryID = selectedrowNode.data.DCConditionLogID;
                params.api.forEachLeafNode(function (NewrowNode, index) {
                    if ((NewrowNode.data.DCConditionLogID === dryHistoryID)) {
                        selectedrowNode = NewrowNode;
                        return false;
                    }
                });
                $.each(self.state.selectedItems, function (index, item) {
                    if (item.DCConditionLogID == selectedrowNode.data.DCConditionLogID) {
                        flag = true;
                        return false;
                    }
                });
                if (!flag)
                    params.api.deselectAll();
                selectedrowNode.setSelected(true);
            }
            /*var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
            var tempArray = [];// if sort is clicked save in temp array
            params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
                tempArray.push(rowNode);
            });
            var resortitem = tempArray[selected.rowIndex];
            var sortflage = false;
            var parentEventId = resortitem.data.ParentEventID;
            params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
                if ((NewrowNode.data.ParentEventID === parentEventId)) {
                    selectedrowNode = NewrowNode;
                    return false;
                }
            });
            $.each(self.state.selectedItems, function (index, item) {
                if (item.ParentEventID == selectedrowNode.data.ParentEventID) {
                    flag = true;
                    return false;
                }
            });
            if (!flag)
                params.api.deselectAll();
            params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
            */
            var height = $(window).height() - 200;
            var halfheight = ($(window).height()) / 2;
            var top = e.pageY + 5;
            if (height < top) {
                top = (top - halfheight) + 310;
            }

            var left = e.pageX;
            $(".context-menu").css({
                top: top + "px",
                left: left + "px"
            });

            $(".context-menu").show();
            e.preventDefault();
            return false;
        });

        $(document).contextmenu(function () {
            return false;
        });

        $(document).bind('contextmenu click', function () {
            $(".context-menu").hide();
        });

        $('.context-menu').bind('contextmenu', function () {
            return false;
        });
        $('.context-menu').on('click', 'li', function () {
            $(".context-menu").hide();
        });
    }

    exportToExcel() {
        var arrData;
        var gridName = '';
        var r = colDefs;
        $("#globalLoader").show();
        if (this.props.IsDry == true) {
            gridName = 'HistoryStatusGrid';
            arrData = self.state.selectedItems;

            try {
                //Excel.InitializeExcelExport(arrData, r, gridName);
                //PopupWindow.showErrorMessage("Alert", "Data exported successfully.");                
                var uri = Excel.InitializeChildGridExportToExcel(arrData, r, gridName);
                this.state.exportFields.ExportData = JSON.stringify(uri);
                var sheetData = { HeaderData: [], ColumnData: [] };
                sheetData = Excel.ConvertCSVToJSon(uri);
                GridToolBarExcel.applySheetData(sheetData, gridName);
            }
            catch (ex) {
                $("#globalLoader").hide();
                PopupWindow.showErrorMessage("Alert", "Error in data export.");
            }
        }
        else {
            gridName = 'RCDHistoryStatusGrid';
            arrData = self.state.selectedItems;

            try {
                //Excel.InitializeExportParent(arrData, r, gridName);
                //PopupWindow.showErrorMessage("Alert", "Data exported successfully.");                
                var uri = Excel.InitializeExportParentToXLSX(arrData, r, gridName);
                this.state.exportFields.ExportData = JSON.stringify(uri);
                var sheetData = { HeaderData: [], ColumnData: [] };
                sheetData = Excel.ConvertCSVToJSon(uri);
                GridToolBar.applySheetData(sheetData, gridName);
            }
            catch (ex) {
                $("#globalLoader").hide();
                PopupWindow.showErrorMessage("Alert", "Error in data export.");
            }
        }
    }

    sendEmail() {
        this.setState({
            emailHtml: self.renderEmailControl()
        })
    }

    renderGridToolBar(gridApiParams: any) {
        if (this.props.IsDry == true) {
            return <GridToolBarExcel refreshGrid={this.ApplyDryHistorySearch.bind(this)} gridData={this.state.rowData} colDefs={colDefs} colDefs2={columnDefs2} parentchild={"C"} gridApiParams={gridApiParams} functionId={"49"} formName={"DryDetailsHistory"} />;
        }
        else {
            return <GridToolBar refreshGrid={this.ApplyDryHistorySearch.bind(this)} gridData={this.state.rowDataForRCD} colDefs={colDefs} colDefs2={columnDefs2} parentchild={"P"} formName={"DryDetailsHistory"} />;
        }
    }

    renderEmailControl() {
        if (this.props.IsDry == true) {
            return <EmailControlExcel reeferStatusResult={this.state.selectedItems} columnDefinition={colDefs} colDefs2={columnDefs2} parentchild={"C"} formname={"DryHistory"}></EmailControlExcel>;
        }
        else {
            return <EmailControl reeferStatusResult={this.state.selectedItems} columnDefinition={colDefs} colDefs2={columnDefs2} parentchild={"P"} formname={"DeviceHistory"}></EmailControl>;
        }
    }

    onGridScroll(params: any) {
        $(".context-menu").hide();
        $("#contextmenu").hide();
    }

    groupRowInnerRenderer(params) {
        //self.clearGridRowSelection(params);
        var fieldName = params.node.field;
        var fieldValue = params.node.key;

        var colDef = params.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
        var columnDisplayName = colDef[0].colDef.headerName;
        if (fieldValue == "-NA-" || fieldValue == "-999")
            return "*No " + columnDisplayName;

        switch (fieldName.toString().trim()) {
            case "BatteryStatus":
                return Formatters.DryPwrStateFormatterGrouping(fieldValue);
            case "TripStatusCdAndDFlag":
                return Formatters.TripStatusFormatterGrouping(fieldValue);
            case "customername":
                return fieldValue == JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName ? "*No Assigned To" : fieldValue;
            case "Door1Open":
                return Formatters.DoorFormatterGrouping(fieldValue);
            case "RSSI":
                return Formatters.RSSIFormatterGrouping(fieldValue);
            case "CommentExistsDC":
                return Formatters.CommentExistsGrouping(fieldValue);
            case "EventDTTM":
            case "DeviceDataTime":
            case "CreatedDTTM":
                return Formatters.dateTypeGrouping(fieldValue, fieldName, params);
            case "GPSCoords":
                return Formatters.GPSCoordsFormatterGrouping(fieldValue, params);
            default:
                return fieldValue;
        }
    }

    onSaveGridRowGroupState(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    rowGroupItems = currentGropup;
                    selectedColumnIds = preferenceData.SelectedColumnIds;
                    selectedColumnValues = preferenceData.SelectedColumnValues;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
                else {
                    // if no userpreference record in db 
                    rowGroupItems = currentGropup;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    // var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, SelectedRowGroups: rowGroupItems };
                    var rowGroupDataToSave = { SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(rowGroupDataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });

                }
            });
    }

    onFirstDataRendered(params) {
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    rowGroupItems = preferenceData.SelectedRowGroups
                    if (rowGroupItems != null && rowGroupItems != undefined && rowGroupItems.length > 0) {
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setRowGroupColumns(rowGroupItems);
                    }
                }
            });

    }

    public render() {
        var groupRowRendererParams: any = {
            innerRenderer: this.groupRowInnerRenderer
        };
        var excelStyles: any = [
            {
                id: 'bigInt',
                dataType: 'string',
                font: {
                    size: 12
                },

            },
            {
                id: 'myExcelStyle',
                font: {
                    size: 12,
                }
            },
            {
                id: 'header',
                font: {
                    size: 14,
                },
            },
        ];
        return <div>
            <div className='control_container'>
                <div className='row'>
                    <div className='col-lg-5'> </div>
                    {
                        this.props.IsDry == true ?
                            <div className='col-lg-6 px-0'>
                                <div className='col-lg-1'><span className='float-end col-form-label'>From:</span></div>
                                <div className='col-lg-5 px-0'>
                                    <div className="input-group date">
                                        <DateTime value={moment(new Date(this.state.HistoryFilters.FromDate))}
                                            pickerOptions={{ format: "MM/DD/YYYY hh:mm A", showClose: true, maxDate: moment(new Date(this.state.PreferenceDTTM)).endOf('day').toString() }} 
                                            onChange={this.FromDateChange.bind(this)}
                                            className=""
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-1 px-0'><span className='float-end col-form-label'>To:</span></div>
                                <div className='col-lg-5 pe-0'>
                                    <div className="input-group date">
                                        <DateTime value={moment(new Date(this.state.HistoryFilters.ToDate))}
                                            pickerOptions={{ format: "MM/DD/YYYY hh:mm A", showClose: true, maxDate: moment(new Date(this.state.PreferenceDTTM)).endOf('day').toString() }}
                                            onChange={this.ToDateChange.bind(this)}
                                            className=""
                                        />
                                    </div>
                                </div>
                            </div>
                            : <div className='col-lg-6 px-0'>
                                <div className='col-lg-1'><span className='float-end col-form-label'>From:</span></div>
                                <div className='col-lg-5 px-0'>
                                    <div className="input-group date">
                                        <DateTime value={moment(new Date(this.state.HistoryFiltersForRCD.FromDate))}
                                            pickerOptions={{ format: "MM/DD/YYYY hh:mm A", showClose: true, maxDate: moment(new Date(this.state.PreferenceDTTM)).endOf('day').toString() }} 
                                            onChange={this.RcdFromDateChange.bind(this)}
                                            className=""
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-1 px-0'><span className='float-end col-form-label'>To:</span></div>
                                <div className='col-lg-5 pe-0'>
                                    <div className="input-group date">
                                        <DateTime value={moment(new Date(this.state.HistoryFiltersForRCD.ToDate))}
                                            pickerOptions={{ format: "MM/DD/YYYY hh:mm A", showClose: true, maxDate: moment(new Date(this.state.PreferenceDTTM)).endOf('day').toString() }} 
                                            onChange={this.RcdToDateChange.bind(this)}
                                            className=""
                                        />
                                    </div>
                                </div>
                            </div>
                    }
                    <div className='col-lg-1 ps-0'>
                        <button type='button' onClick={this.ApplyDryHistorySearch.bind(this)} className='btn btn-primary'>Search</button>
                    </div>
                </div>
            </div>
            <div>{this.state.GridToolBarHtml}</div>
            <div className='row'>
                <div className='col-md-12'>
                    {
                        this.props.IsDry == true ?
                            <div className="ag-theme-fresh" id="HistoryStatusGrid">
                                <AgGridReact
                                    columnDefs={colDefs}
                                    rowData={this.state.rowData}
                                    onGridReady={this.onDryGridReady}
                                    animateRows={true}
                                    rowGroupPanelShow={this.state.rowGroupPanelShow}
                                    autoGroupColumnDef={this.state.autoGroupColumnDef}
                                    suppressDragLeaveHidesColumns={true}
                                    suppressMakeColumnVisibleAfterUnGroup={true} 
                                    onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                                    onColumnRowGroupChanged={this.onSaveGridRowGroupState.bind(this)}
                                    groupRowRendererParams={groupRowRendererParams}
                                    //groupRowInnerRenderer={this.groupRowInnerRenderer}
                                    defaultGroupOrderComparator={
                                        function (nodeA, nodeB) {
                                            var AnodeIsNumber = Number(nodeA.key);
                                            var BnodeIsNumber = Number(nodeB.key);
                                            var AnodeIsString = String(nodeA.key);
                                            var BnodeIsString = String(nodeB.key);

                                            if (!isNaN(AnodeIsNumber) && !isNaN(BnodeIsNumber)) {
                                                return AnodeIsNumber - BnodeIsNumber;
                                            } else {
                                                return AnodeIsString.localeCompare(BnodeIsString);
                                            }
                                        }
                                    }
                                    groupDisplayType='groupRows'
                                    pagination={true}
                                    enableRangeSelection={true}
                                    rowSelection={'multiple'}
                                    accentedSort={true}
                                    excelStyles={excelStyles}
                                    rowDeselection={true}
                                    onSelectionChanged={this.onSelectionChanged}
                                    allowContextMenuWithControlKey={true}
                                    onCellContextMenu={this.getContextMenuItems}
                                    paginationPageSize={this.state.pageSize}
                                    onBodyScroll={this.onGridScroll}>
                                </AgGridReact>
                            </div>
                            :
                            <div className="ag-theme-fresh" id="RCDHistoryStatusGrid">
                                <AgGridReact
                                    columnDefs={colDefs}
                                    rowData={this.state.rowDataForRCD}
                                    onGridReady={this.onRcdGridReady}                                    
                                    pagination={true}
                                    accentedSort={true}
                                    enableRangeSelection={true}
                                    rowSelection={'multiple'}
                                    excelStyles={excelStyles}
                                    rowDeselection={true}
                                    onSelectionChanged={this.onRCDSelectionChanged}
                                    allowContextMenuWithControlKey={true}
                                    onCellContextMenu={this.getRCDContextMenuItems}
                                    paginationPageSize={this.state.pageSize}
                                    onBodyScroll={this.onGridScroll}>
                                </AgGridReact>
                            </div>
                    }
                    <div className='pageSize'>
                        <span className='pageSize-lable'>Page Size:</span>
                        <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className='row' id='contextmenu'>
                <div className='context-menu'>
                    <ul>
                        <li id="liexportToExcel" onClick={this.exportToExcel.bind(this)}>Export to Excel</li>
                        <li id="lisendEmail" data-bs-toggle="modal" data-bs-target="#sendEmail" onClick={this.sendEmail.bind(this)}>Send Email</li>
                    </ul>
                </div>
            </div>
            <div className="modal fade" id="sendEmail" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Send Email</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>
                            
                        </div>
                        <div className="modal-body">
                            {this.state.emailHtml}
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

class DryHistoryFilter {
    AssetNumber: string;
    DeviceNumber: string;
    FromDate: string;
    ToDate: string;
    EventCode: string;
}
class RcdHistorySearchFilters {
    FromDate: string;
    ToDate: string;
    Units: string;
}

